/**
 * Type-safe way to get the non-nullable item from an array
 *
 * @param T - The type of the array
 * @returns The non-nullable item from the array
 */
export type NonNullableArrayItem<T> = NonNullable<T> extends Array<infer U>
  ? NonNullable<U>
  : never;

/**
 * Resolves a function or an object to its type
 * Helps to see the types properly when you mouse over the object
 *
 * @param T - The type to resolve
 * @returns The resolved type
 */
export type Resolve<T> = T extends Function ? T : { [K in keyof T]: T[K] };

/**
 * Type-safe way to get array of values from an enum
 *
 * @param enumObject - The enum object to get values from
 * @returns An array of the enum values
 */
export function getEnumValues<T extends { [key: string]: string }>(
  enumObject: T,
): T[keyof T][] {
  return Object.values(enumObject) as Array<T[keyof T]>;
}
